module.exports = __webpack_public_path__ + "img/template1.017a0da9.png";